import React from 'react';
import { LucideIcon } from 'lucide-react';
import Button from './Button';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action,
  className = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-16 px-4 text-center ${className}`}>
      {Icon && (
        <div className="w-24 h-24 liquid-glass rounded-full flex items-center justify-center mb-6">
          <Icon 
            size={48} 
            className="opacity-50" 
            style={{color: 'var(--liquid-text-muted)'}}
          />
        </div>
      )}
      
      <h3 className="text-2xl font-bold mb-4 liquid-glow-strong" style={{color: 'var(--liquid-text-primary)'}}>
        {title}
      </h3>
      
      {description && (
        <p className="mb-8 max-w-md mx-auto opacity-70 leading-relaxed" style={{color: 'var(--liquid-text-muted)'}}>
          {description}
        </p>
      )}
      
      {action && (
        <Button
          variant="primary"
          size="lg"
          onClick={action.onClick}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;




